module.exports = __webpack_public_path__ + "static/img/mybank@2x.49292d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK/mybank@2x.png
// module id = LiLv
// module chunks = 70